import { createServerFn } from "@tanstack/react-start";
import { requireSupabaseAuth } from "@/integrations/supabase/auth-middleware";
import { studyTutorInput } from "./study-tutor-input";

export const processStudyQuestion = createServerFn({ method: "POST" })
  .middleware([requireSupabaseAuth])
  .inputValidator(input => studyTutorInput.parse(input))
  .handler(async ({ context, data }) => {
    const { executeStudyTutor } = await import("./study-tutor.server");
    return executeStudyTutor(context, data, import.meta.env.DEV);
  });
